import { render } from "./Bugbounty.vue?vue&type=template&id=16cfa0e2"
import script from "./Bugbounty.vue?vue&type=script&lang=js"
export * from "./Bugbounty.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__